import { render } from "./AdminPayments.vue?vue&type=template&id=3d30617b&scoped=true"
import script from "./AdminPayments.vue?vue&type=script&lang=js"
export * from "./AdminPayments.vue?vue&type=script&lang=js"

import "./AdminPayments.vue?vue&type=style&index=0&id=3d30617b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d30617b"]])

export default __exports__